// extracted by mini-css-extract-plugin
export default {"add":"ManagerBook_add__Gjpzg"};